/**
 * @description 嵌套对象打平
 * @param {object} obj
 * @param {name} obj的属性名
 */
export const formatObj = (node, name) => {
  const arr = {};
  formatObjLoop(node, name, arr);
  return Object.values(arr);
};

function formatObjLoop(node, name, arr) {
  if (!node.visible) {
    return;
  }
  if (node.data.id) {
    arr[node.data.id] = node.data;
  }
  if (node.hasOwnProperty(name) && Array.isArray(node[name])) {
    node[name].forEach(childNode => {
      if (!childNode.visible) {
        return;
      }
      arr[childNode.data.id] = childNode.data;
      formatObjLoop(childNode, name, arr);
    });
  }
}
